import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/content";

export default function NewsCard({
  article,
  layout = "vertical",
}: {
  article: NewsArticle;
  layout?: "vertical" | "horizontal";
}) {
  if (layout === "horizontal") {
    return (
      <article className="group flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-accent-300 sm:flex-row">
        <Link to={`/news/${article.id}`} className="block w-full sm:w-52 sm:shrink-0">
          <div className="aspect-[16/10] w-full overflow-hidden rounded-md bg-background-200">
            <img
              src={article.cover}
              alt={`${article.title} 配图`}
              title={`${article.title} 拍摄花絮`}
              className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
            />
          </div>
        </Link>
        <div className="flex flex-1 flex-col justify-center">
          <div className="flex items-center gap-2 text-xs text-foreground-500">
            <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">
              {article.category}
            </span>
            <time>{article.date}</time>
          </div>
          <Link to={`/news/${article.id}`}>
            <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
              {article.title}
            </h3>
          </Link>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
            {article.excerpt}
          </p>
        </div>
      </article>
    );
  }

  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-accent-300">
      <Link to={`/news/${article.id}`} className="block">
        <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} 幕后制作故事`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="rounded-full bg-accent-100 px-2 py-0.5 text-accent-900">
            {article.category}
          </span>
          <time>{article.date}</time>
        </div>
        <Link to={`/news/${article.id}`}>
          <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {article.title}
          </h3>
        </Link>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {article.excerpt}
        </p>
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span>{article.author}</span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {(article.heat / 1000).toFixed(1)}k
          </span>
        </div>
      </div>
    </article>
  );
}